export default __webpack_public_path__ + "static/media/contact_anime.1f3936c4.png";